import * as ACTIONS from '../actionTypes/priceOfferListActionTypes';
import { getPriceOfferListPackages } from '../../services/priceOfferList';

export const init = (priceOfferSearchInfo, defaultSortOrder) => {
  return async (dispatch) => {
    const { apiUrl, siteId, priceOfferId, userId, isCharter, useUpsellUrl } = priceOfferSearchInfo;

    const priceOffer = await getPriceOfferListPackages(apiUrl, siteId, priceOfferId, userId, isCharter, useUpsellUrl);
    const { packages: priceOfferPackages, filterOptions: filterOptionLists } = priceOffer;
    if (priceOfferPackages && priceOfferPackages.length >= 1) {
      // Convert string sortValues.departureDate to date object
      const parsedPackages = priceOfferPackages.map((pkg) => {
        const dateObject = new Date(pkg?.sortValues?.departureDate);
        return {
          ...pkg,
          sortValues: {
            ...pkg?.sortValues,
            departureDate: dateObject,
          },
        };
      });
      dispatch({
        type: ACTIONS.INIT_SUCCESS,
        isCharter,
        packages: parsedPackages,
        filterOptions: filterOptionLists,
        defaultSortOrder,
      });
    }
  };
};

// Sort actions
export const setSortOrder = (sortOrder) => {
  return {
    type: ACTIONS.SET_SORT_ORDER,
    sortOrder,
  };
};

// Filter actions
export const addDepartureMonthFilter = (monthToAdd) => {
  return {
    type: ACTIONS.ADD_DEPARTURE_MONTH_FILTER,
    monthToAdd,
  };
};

export const removeDepartureMonthFilter = (monthToRemove) => {
  return {
    type: ACTIONS.REMOVE_DEPARTURE_MONTH_FILTER,
    monthToRemove,
  };
};

export const addDepartureAirportFilter = (airportToAdd) => {
  return {
    type: ACTIONS.ADD_DEPARTURE_AIRPORT_FILTER,
    airportToAdd,
  };
};

export const removeDepartureAirportFilter = (airportToRemove) => {
  return {
    type: ACTIONS.REMOVE_DEPARTURE_AIRPORT_FILTER,
    airportToRemove,
  };
};

export const setMaxPriceFilter = (maxPrice) => {
  return {
    type: ACTIONS.SET_MAX_PRICE_FILTER,
    maxPrice,
  };
};

export const removeMaxPriceFilter = () => {
  return {
    type: ACTIONS.REMOVE_MAX_PRICE_FILTER,
  };
};

export const addDestinationFilter = (destinationToAdd) => {
  return {
    type: ACTIONS.ADD_DESTINATION_FILTER,
    destinationToAdd,
  };
};

export const removeDestinationFilter = (destinationToRemove) => {
  return {
    type: ACTIONS.REMOVE_DESTINATION_FILTER,
    destinationToRemove,
  };
};

export const clearAllFilters = () => {
  return {
    type: ACTIONS.CLEAR_ALL_FILTERS,
  };
};
